<!-- The NA three-color patriotic star — used as the currency mark -->
<script setup>
defineProps({ size: { type: Number, default: 24 } })
</script>

<template>
    <svg :width="size" :height="size * (926/1003)" viewBox="0 0 1003 926" fill="none">
        <path d="M625.72 795.57L499.73 706.3L373.75 795.79L185.15 925.56L307.33 568.84L182.26 481.57L0 344.51L380.84 344.45L428.71 199.75L495.72 0L571.23 200.7L618.7 344.43L1002.81 344.53L817.87 480.83L692.06 568.98L739.17 705.8L811.13 919.38L625.73 795.58Z" fill="#C8102E"/>
        <path d="M499.78 679.79L365.56 775.46L226.47 871.05L332.95 560.49L194.7 464.03L64.46 366.04L396.42 365.9L496.9 64.21L550.91 207.69L603.17 365.93L937.36 366.02L803.88 464.71L666.36 560.61L770.72 866.68L636.48 777.24Z" fill="#fff"/>
        <path d="M576.12 668.25L500.41 614.51L425.04 668.02L328.6 734.32L395.38 539.5L318.81 486.05L227.28 417.07L435.45 416.96L498.32 228.3L536.7 330.21L565.3 416.99L775.06 417.11L681.35 486.44L605.22 539.53L670.28 731.03Z" fill="#12356E"/>
    </svg>
</template>
